/**
 * Created by rae on 3/26/2018.
 */
window.angular.module('image.service', []).
factory('ImageService', ['$location', '$http', 'SweetAlert', '$timeout', '$rootScope', '$state','UidService', 'QiniuToken',
    function ($location, $http, SweetAlert, $timeout, $rootScope, $state, UidService, QiniuToken) {

        /**
         * png,jpg等图片格式转base64
         * @param url
         * @param callback
         * @param outputFormat
         */
        this.convertImgToBase64 = function (url, callback, outputFormat) {
            var canvas = document.createElement('CANVAS'),
                ctx = canvas.getContext('2d'),
                img = new Image;
            img.crossOrigin = 'Anonymous';
            img.setAttribute('crossOrigin', 'anonymous');
            img.onload = function () {
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.imageSmoothingEnabled = true;
                ctx.mozImageSmoothingEnabled = true;
                ctx.webkitImageSmoothingEnabled = true;
                ctx.msImageSmoothingEnabled = true;
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL(outputFormat || 'image/png');
                // callback.call(this, dataURL);
                callback.call(this, dataURLtoBlobs(dataURL));
                canvas = null;
            };
            img.src = url;
        };

        /**
         * base64转Blob
         * @param dataurl
         * @returns {*}
         */
        this.dataURLtoBlob=function(dataurl) {
            return dataURLtoBlobs(dataurl);
        };
        function dataURLtoBlobs(dataurl) {
            var arr = dataurl.split(','),
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            var createObjectURL = function (blob) {
                return window[window.webkitURL ? 'webkitURL' : 'URL']['createObjectURL'](blob);
            };
            var fileURL = URL.createObjectURL(new Blob([u8arr], {type: 'image/*'}));
            return fileURL;
        }

        this.backendUploadPics = function(file, domain, token, callback, errorback) {
            // 如果 file 上已经有宽高信息则直接使用，否则加载图片获取尺寸
            if (file.width !== undefined && file.height !== undefined) {
                doUpload(file.width, file.height, token, false);
            } else {
                var img = new Image();
                var objectUrl = URL.createObjectURL(file);
                img.onload = function() {
                    URL.revokeObjectURL(objectUrl);
                    doUpload(img.width, img.height, token, false);
                };
                img.onerror = function() {
                    URL.revokeObjectURL(objectUrl);
                    // 加载失败时兜底，仅按文件大小判断
                    doUpload(0, 0, token, false);
                };
                img.src = objectUrl;
            }

            function doUpload(width, height, uploadToken, isRetry) {
                var formData = new FormData();
                var _key ="gallery-" + UidService.get()
                // 超过50M 或超大尺寸 增加xl大图标识
                if(file.size >= 20971520 || width > 30000 || height > 30000 || (width*height)>150000000){
                    _key += '-xl'
                }
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', _key);
                formData.append('token',  uploadToken);
                var reader2 = new FileReader();
                reader2.readAsArrayBuffer(file)
                reader2.onloadend = function(e) {
                    formData.append('crc32', CRC32.buf(new Uint8Array(this.result)));
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: true,
                        contentType: false,
                        processData: false,
                        success: function(data) {
                            callback.call(this, data, file);
                        },
                        error: function(request) {
                            if (!isRetry && isTokenError(request)) {
                                // 401 / "expired token" -> 刷新token后重试一次
                                QiniuToken.refresh('get', {}, function(newToken) {
                                    doUpload(width, height, newToken, true);
                                });
                            } else {
                                errorback.call(this, file)
                            }
                        }
                    });
                };
            }
        }

        function isTokenError(request) {
            return request && (request.status === 401 ||
                (request.responseText && request.responseText.indexOf('expired token') !== -1));
        }

        return this;

    }]);
